import { AxiosRequestConfig } from 'axios';
import { UploadFilesProps } from './file-provider.types';
import { DownloadType } from '../../constants';

class FileProviderRequestConfig {
  uploadFiles = ({ files, entityId, documentTypeId, logicalName }: UploadFilesProps): AxiosRequestConfig => {
    const data = new FormData();
    files.forEach(file => {
      data.append('files', file, file.name);
    });
    data.append('entityId', entityId);
    data.append('documentTypeId', documentTypeId);
    data.append('logicalName', logicalName);

    return {
      method: 'POST',
      url: 'fileProvider/uploadFiles',
      responseType: 'blob',
      data
    };
  };

  moveToRecycleBin = (logicalName: string, storageFileId: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'fileProvider/moveToRecycleBin',
    responseType: 'blob',
    data: {
      logicalName,
      storageFileId
    }
  });

  downloadFile = (storageFileId: string, logicalName: string, downloadType: DownloadType): AxiosRequestConfig => ({
    method: 'POST',
    url: 'FileProvider/DownloadFile',
    responseType: 'blob',
    data: {
      storageFileId,
      logicalName,
      downloadType
    }
  });
}

export const fileProviderRequestConfig = new FileProviderRequestConfig();
